// This file is generated via scripts/build-static-config.js
// Do not modify directly as changes will be overwritten in CI

export const CONFIGURATION = {
  country: 'de',
  brand: 'bk',
  env: 'prod',
  graphqlEnv: 'prod',
  graphqlGatewayEnv: '',
  sanityEnv: 'prod',
  platform: 'web',
  commitRef: '83c962669f009f746be3196840c8f1325a7d770b',
  releaseTimestamp: '1683117126',
  sanityDataset: '',
  sanityProjectId: 'czqk28jt',
  appFlowBuildId: '',
  adyen: {
    clientKey: 'live_L6BRV3FK4FFZVN2XFXYC6WCMRALGGK6O',
    environment: 'live',
    urlPrefix: 'https://checkoutshopper-live.adyen.com',
    ideal: {
      idealBanks: [],
    }
  },
  apiKeys: {
    amplitude: '',
    branch: 'key_live_piz0E0HC3o5d4jtgYGmxdlphvraJwlMf',
    braze: '550413e9-770e-4730-adf6-be1cab4b1a74',
    bringg: '',
    googleMaps: 'AIzaSyDOtGSKPthz3am_QTmuavFu42QiIcVORm0',
    googleMapsAndroid: '',
    googleMapsIOS: '',
    googleMapsWeb: '',
    googleAnalytics: '',
    tomtom: '',
    launchDarkly: '6045e341fc9ae60ef099f6c3',
    launchDarklyMobileKey: '',
    logRocket: 'mj7uvx/ctg-prod',
    mParticle: 'eu1-acfb9c5b97fc3845bb662dcc8d7116f1',
    radar: '',
  },
  apple: {
    merchantId: 'merchant.com.bk.native.de.prod',
    migrationMerchantId: '',
    paymentsNetworks: ['AmEx','MasterCard','Visa','Discover'],
    prepaidMerchantId: '',
    migrationPrepaidMerchantId: '',
  },
  aws: {
    gqlApiUrl: 'https://euc1-prod-bk.rbictg.com/graphql',
    gqlGatewayApiUrl: 'https://euc1-prod-bk-gateway.rbictg.com/graphql',
    region: 'eu-central-1',
    userPoolClientId: '62ev1gv53cp9bckrt5gdinrqmj',
    userPoolId: 'eu-central-1_dwCOsnxKY',
  },
  bringg: {
    region: '6',
  },
  datadog: {
    logs: {
      clientToken: 'pubfb47d4dd5c89b9a25a8bb3d2268d79a9',
      dataCenter: '',
    },
    rum: {
      applicationId: '2e33906c-d3fb-4f81-be7c-a69cf59904e2',
      clientToken: 'pubfb47d4dd5c89b9a25a8bb3d2268d79a9',
      dataCenter: '',
    },
  },
  firstData: {
    corporateStoreId: '',
  },
  forter: {
    siteId: '6ebc7d54b003',
  },
  google: {
    paymentsEnvironment: 'prod',
    paymentsGateway: 'computop',
    paymentsGatewayMerchantId: {
      ca: '',
      us: '',
    },
    migrationPaymentsGateway: '',
    migrationPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    },
    paymentsNetworks: ['AMEX','MASTERCARD','VISA','DISCOVER'],
    prepaidPaymentsGateway: '',
    prepaidPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    },
    migrationPrepaidPaymentsGateway: '',
    migrationPrepaidPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    }
  },
  googleAdManager: {
    campaignId: '',
  },
  googleTagManager: {
    containerId: 'GTM-THS86W5',
  },
  oneTrust: {
    cookieCompliance: {
      consentCategoryBranch: 'C0004',
      consentCategoryBraze: 'C0050',
      consentCategoryMParticle: 'C0001',
      globalConsentState: 'Opt-In',
      scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      scriptId: '3445d691-3ebe-4414-948a-a8281acf4595',
    },
    deleteAccountUrl: 'https://privacyportal-de.onetrust.com/webform/d1fd6c0f-46d0-43f3-b672-3bfdec055fe8/253af85b-870f-45c8-93bb-b1bda2ef5b90',
  },
  pypestream: {
    scriptUrl: '',
    appId: '',
  },
  restaurants: {
    displayEnv: 'prod',
    validMobileOrderingEnvs: ['alpha','beta','live'],
  },
  urls: {
    braze: 'https://customer.iad-03.braze.com/api/v3',
    firstData: 'https://api.payeezy.com',
    firstDataTh: 'https://api.payeezy.com',
    webBaseUrl: '',
    thDigital: '',
  },
  tokenEx: {
    publicKey: '',
  },
  vrPayment: {
    braintreeTokenizationKey: 'production_pgq6827b_3zz878p6xyfg94v8',
  },
  orbital: {
    baseUrl: '',
    subscriberId: '',
    pieFormat: '',
    mode: '',
  },
  timeFormat: 'HH:mm',
  dateFormat: '',
  addressFormat: '',
  maxCartQuantity: 25,
  appStoreDeeplink: '',
};